import React, { useCallback } from 'react';
import { Field, Form, Formik } from 'formik';
import { merge } from 'lodash';
import * as yup from 'yup';

import { useConfigurations } from 'features/accountPlatforms/facebook/useConfigurations';
import CenteredSpinner from 'features/ui/CenteredSpinner';
import FormButton from 'shared/components/FormButton';
import TextInput from 'shared/components/TextInput';

import { CONFIGURATION_COPY } from 'shared/config/copy/configurationCopy';
import { noOp } from 'shared/defaults';
import { makeLabel } from 'shared/lib/formik';
import { BUTTON_VARIANTS } from 'shared/styles/button';

import { Button, Flex, Text } from '../../display';

import styles from './styles';

// fieldnames
const NAME = 'name';

const initialValues = {
  name: '',
};

const validationSchema = yup.object({
  name: yup.string().customRequiredString(),
});

interface Values {
  name: string;
}

interface Props {
  type: string;
  entityType: string;
  entityId: number;
  onRequestClose: Function;
  formData: { [field: string]: any };
}

const SaveConfigurationForm: React.FC<Props> = ({ type, entityType, entityId, onRequestClose = noOp, formData }) => {
  const { loading, createConfiguration } = useConfigurations();

  const saveCallback = useCallback(
    (nameData) => {
      let configObj = {
        type,
        entityType,
        entityId,
        value: formData,
        description: '',
      };
      configObj = merge(configObj, nameData);
      createConfiguration(configObj);
      onRequestClose();
    },
    [formData],
  );

  return (
    <Flex css={styles}>
      <Formik<Values> onSubmit={saveCallback} initialValues={initialValues} validationSchema={validationSchema}>
        <Form>
          <Text className="form__body-text">{CONFIGURATION_COPY.FORM_TEXT_SAVE_CONFIGURATION}</Text>
          <Field
            component={TextInput}
            name={NAME}
            label={makeLabel(NAME, true)}
            placeholder={CONFIGURATION_COPY.PLACEHOLDER_CONFIGURATION_NAME}
          />
          <Flex className="form__footer">
            <Button variant={BUTTON_VARIANTS.OUTLINE} onClick={() => onRequestClose()}>
              Cancel
            </Button>
            <FormButton>{CONFIGURATION_COPY.BUTTON_SAVE_CONFIGURATION}</FormButton>
          </Flex>
        </Form>
      </Formik>
      {loading && <CenteredSpinner />}
    </Flex>
  );
};
export default SaveConfigurationForm;
